import { ReactComponent as Upload } from "images/upload_icon.svg";
import { cn } from "utils";

const UploadButton = ({
  onClick,
  loadingWidget,
  uploadInProgress,
  label,
  className,
  uploadButtonClassName,
  title,
}) => {
  return (
    <button
      className={cn(
        "text-gray-800 flex items-center mb-1 pl-2 gap-x-1",
        className,
        uploadButtonClassName
      )}
      type="button"
      disabled={loadingWidget}
      loading={uploadInProgress}
      onClick={onClick}
      title={title}
    >
      <Upload className="w-5 h-5" />
      {loadingWidget ? "Loading..." : uploadInProgress ? "Uploading..." : label}
    </button>
  );
};

export default UploadButton;
